import { Box, Grid, Paper, Stack, Typography } from "@mui/material";
import COLORS from "../../../../styles/colors";
import { messages } from "./config/messages";
import useDeviceSize from "../../../../hooks/useDeviceSize";
import { StyledBoldText, StyledNormalText } from "./styles";

// const FAST_FACTS_LIST: Array<{ title: string; value: string }> = [
//   {
//     title: "Successful Years",
//     value: "10+",
//   },
//   {
//     title: "SaaS Products",
//     value: "10+",
//   },
//   {
//     title: "Talented People",
//     value: "75+",
//   },
//   {
//     title: "Domains",
//     value: "5+",
//   },
//   {
//     title: "Repeat Business",
//     value: "80%",
//   },
//   {
//     title: "YoY Growth",
//     value: "20%",
//   },
//   {
//     title: "B2B SaaS IPs",
//     value: "2",
//   },
//   {
//     title: "Users with V2STech Powered Apps",
//     value: "1M",
//   },
// ];

const factItems = [
  { boldText: "1M", regularText: "Users with V2STech Powered Apps", boldFirst: true },
  {
    boldText: "SSL, OWASP, SSO, 2FA",
    regularText: "Security:",
    boldFirst: false,
  },
  { boldText: "PCI-DSS, GDPR", regularText: "Compliance:", boldFirst: false },
  { boldText: "10+", regularText: "Successful Years:", boldFirst: false },
  { boldText: "10+", regularText: "SaaS Products:", boldFirst: false },
  { boldText: "5+", regularText: "Domains:", boldFirst: false },
  { boldText: "80%", regularText: "Repeat Business", boldFirst: true },
];

type FactItemWrapperProps = {
  isOnMobile: boolean;
} & React.PropsWithChildren;
const FactItemWrapper = ({ children, isOnMobile }: FactItemWrapperProps) => (
  <Grid xs={5.5} md={2.8}>
    <Paper
      elevation={0}
      sx={{
        backgroundColor: COLORS.WHITE,
        color: COLORS.DARK_BLUE,
        paddingBlock: 2,
        paddingInline: 2,
        height: 86,
        borderRadius: 4,
      }}
    >
      <Stack spacing={2} direction="row" alignItems="center" height="100%">
        {children}
      </Stack>
    </Paper>
  </Grid>
);

const FastFacts = () => {
  const { isOnMobile } = useDeviceSize();

  return (
    <Box bgcolor={COLORS.PRIMARY_BLUE}>
      <Typography
        textAlign="center"
        color="white"
        variant="h4"
        fontWeight="600"
        fontSize="30px"
      >
        {messages.fastFacts}
      </Typography>
      <Grid
        container
        mt={2}
        direction="row"
        rowGap={5.5}
        columnGap={3}
        paddingBlock={6}
        paddingInline={0}
        justifyContent="center"
        px={{ xs: 0, sm: 0, md: 0, lg: 16, xl: 16 }}
      >
        {/* {FAST_FACTS_LIST.map(({ title, value }) => (
          <Grid key={title} xs={5.5} md={2.8}>
            <Paper
              elevation={0}
              sx={{
                backgroundColor: COLORS.WHITE,
                color: COLORS.DARK_BLUE,
                paddingBlock: 2,
                paddingInline: 2,
                height: isOnMobile ? 110 : 86,
                borderRadius: 4,
              }}
            >
              <Stack
                spacing={2}
                direction="row"
                alignItems="center"
                height="100%"
                divider={
                  <Divider
                    color={COLORS.LIGHT_BLUE}
                    orientation="vertical"
                    flexItem
                  />
                }
              >
                <Typography
                  variant="h5"
                  fontWeight="bold"
                  textAlign="center"
                  width={48}
                  fontSize="25px"
                >
                  {value}
                </Typography>
                <Typography variant="h5" lineHeight={1.2} fontSize="20px">
                  {title}
                </Typography>
              </Stack>
            </Paper>
          </Grid>
        ))} */}

        {/* {valuesWithHighlights.map((item, idx) => (
          <Grid key={idx} xs={5.5} md={2.8}>
            <Paper
              elevation={0}
              sx={{
                backgroundColor: COLORS.WHITE,
                color: COLORS.DARK_BLUE,
                paddingBlock: 2,
                paddingInline: 2,
                height: isOnMobile ? 110 : 86,
                borderRadius: 4,
              }}
            >
              <Box display="flex" alignItems="center">
                {Object.keys(item).map((key, idx) =>
                  key === "highlight" ? (
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      textAlign="center"
                      width={48}
                      fontSize="25px"
                      key={idx}
                    >
                      {item[key]}
                    </Typography>
                  ) : (
                    <Typography
                      variant="h5"
                      lineHeight={1.2}
                      fontSize="20px"
                      key={idx}
                    >
                      {item[key as keyof typeof item]}
                    </Typography>
                  )
                )}
              </Box>
            </Paper>
          </Grid>
        ))} */}

        {factItems.map((item, index) => (
          <FactItemWrapper key={index} isOnMobile={isOnMobile}>
            {item.boldFirst ? (
              <>
                <StyledBoldText variant="h5">{item.boldText}</StyledBoldText>
                <StyledNormalText variant="h5">
                  {item.regularText}
                </StyledNormalText>
              </>
            ) : (
              <>
                <StyledNormalText variant="h5">{item.regularText}</StyledNormalText>
                <StyledBoldText variant="h5">{item.boldText}</StyledBoldText>
              </>
            )}
          </FactItemWrapper>
        ))}
      </Grid>
    </Box>
  );
};

export default FastFacts;
